import styled, { css } from 'styled-components'

type HeaderProps = {
  noMargin?: boolean
  color?: string
  textAlign?: 'left' | 'center' | 'right'
}

const defaultHeadingStyles = css<HeaderProps>`
  ${({ theme, noMargin, color, textAlign }) => {
    return `
      color: ${color ?? theme.Colors.Neutrals.Darkest};
      margin-bottom: ${noMargin ? `0px` : theme.UI.SpacingPx.Space4};

      text-align: ${textAlign || 'left'};
    `
  }}
`
const H0 = styled.h1<HeaderProps>`
  ${defaultHeadingStyles}
  ${({ theme }) => theme.Typography.Heading0}
`

const H1 = styled.h1<HeaderProps>`
  ${defaultHeadingStyles}
  ${({ theme }) => theme.Typography.Heading1}
  color: ${({ theme }) => theme.Colors.Neutrals.Darkest};
`

const H2 = styled.h2<HeaderProps>`
  ${defaultHeadingStyles}
  ${({ theme }) => theme.Typography.Heading2}
  color: ${({ theme }) => theme.Colors.Neutrals.Darkest};
`

const H3 = styled.h3<HeaderProps>`
  ${defaultHeadingStyles}
  ${({ theme }) => theme.Typography.Heading3}
  color: ${({ theme }) => theme.Colors.Neutrals.Darkest};
`

const H4 = styled.h4<HeaderProps>`
  ${defaultHeadingStyles}
  ${({ theme }) => theme.Typography.Heading4}
  color: ${({ theme }) => theme.Colors.Neutrals.Darkest};

  ${({ theme, noMargin }) => {
    return `
      margin-bottom: ${noMargin ? `0px` : theme.UI.SpacingPx.Space3};
    `
  }}
`

export { H0, H1, H2, H3, H4 }
